
export type UserTier = 'free' | 'starter' | 'creator' | 'pro';

export interface Subtitle {
  id: number;
  startTime: string; // Format: 00:00:00,000
  endTime: string;   // Format: 00:00:00,000
  text: string;
  translatedText?: string;
}

export interface TokenUsage {
  promptTokenCount: number;
  candidatesTokenCount: number;
  totalTokenCount: number;
}

export interface UsageStats {
  totalInputTokens: number;
  totalOutputTokens: number;
  totalRequests: number;
  estimatedCostUSD: number;
}

export interface SubtitleResponse {
  subtitles: Subtitle[];
  detectedLanguage: string;
  usage?: TokenUsage;
}

export interface HistoryItem {
  id: string;
  uid: string;
  fileName: string;
  originalName: string;
  storagePath: string; // Path in Firebase Storage
  createdAt: any; // Firestore Timestamp
  subtitles: Subtitle[];
  detectedLanguage: string;
  targetLanguage: string;
  usage?: TokenUsage;
  modelUsed?: string;
  expiresAt?: any; // Calculated based on plan
}

export interface Transaction {
  id: string;
  type: 'purchase' | 'bonus' | 'penalty' | 'plan_change' | 'usage';
  amount: number; // Credits added or removed
  description: string;
  timestamp: any;
  adminId?: string; // ID of the admin who performed the action (if applicable)
  metadata?: any; // Extra info like PayPal Order ID or Plan Name
}

export enum ProcessStatus {
  IDLE = 'idle',
  EXTRACTING = 'extracting', // New status for granular progress
  UPLOADING = 'uploading',
  ANALYZING = 'analyzing',
  COMPLETED = 'completed',
  ERROR = 'error'
}

export interface SystemConfig {
  paypalMode: 'sandbox' | 'production';
  paypalSandboxClientId: string;
  paypalProductionClientId: string;
}
